exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".check-users table {\n  table-layout: fixed;\n}\n.check-users table tr {\n  cursor: pointer;\n}\n", ""]);

